import type { RelativeWorkspacePath } from "@codesandbox/pitcher-client";

import { executeVSCodeCommand } from "utils/vscode";

import type { Command } from "../../types";

const CONFIG_FILE_PATH = "/.codesandbox/tasks.json" as RelativeWorkspacePath;

export const useOpenTasksConfigCommand = (): Command => {
  return {
    name: `Open Tasks Configuration`,
    id: "codesandbox.tasks.openOrCreateConfig",
    section: "CodeSandbox Tasks",
    perform: () => {
      executeVSCodeCommand("workbench.explorer.fileView.focus");

      executeVSCodeCommand("codesandbox.openCsbTab", {
        type: "FILE",
        filepath: CONFIG_FILE_PATH,
      });
    },
  };
};
